import { render, staticRenderFns } from "./WorkerList930.vue?vue&type=template&id=6a68b096&scoped=true"
import script from "./WorkerList930.vue?vue&type=script&lang=js"
export * from "./WorkerList930.vue?vue&type=script&lang=js"
import style0 from "./WorkerList930.vue?vue&type=style&index=0&id=6a68b096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a68b096",
  null
  
)

export default component.exports